import React from 'react';
import _ from 'lodash';

import Autocomplete from 'react-autocomplete';
import RaisedButton from 'material-ui/RaisedButton';

const styles = {
    autocomplete: {
        menuStyle: {
            borderRadius: '3px',
            boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
            background: 'rgba(255, 255, 255, 0.9)',
            padding: '2px 0',
            fontSize: '16px',
            position: 'fixed',
            overflow: 'auto',
            maxHeight: '30%',
        },
        wrapperStyle: {
            width: '100%',
        }

    },
    button: {
        labelStyle: {fontSize: '10px'},
        style: {height: '25px'},
        buttonStyle: {height: '25px', lineHeight: '25px'},
    }
};

class GazetterItem extends React.Component {
    constructor(props) {
        super(props);

        this.changeGazetter = _.debounce((state, gazetter) => {
            this.props.changeGazetter(state, gazetter);
        }, 300);

        this.state = {
            name: props.gazetter.GazetterName,
            group: props.gazetter.GazetterType,
            word: props.gazetter.value,
            vocabularies: [],
        };

        this.changeRow = this.changeRow.bind(this);
    }

    changeRow(fields) {
        let state = this.state;

        fields.forEach((item) => {
            _.set(state, item.field, item.value);
        });

        this.setState({
            ...state,
        }, () => {
            this.changeGazetter(state, this.props.gazetter)
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            name: nextProps.gazetter.GazetterName,
            group: nextProps.gazetter.GazetterType,
            word: nextProps.gazetter.value,
            vocabularies: nextProps.listGazetters.filteredList,
        });
    }

    render() {
        const { name, group, word, vocabularies } = this.state;
        const { gazetter, removeGazetter, clearGazetter } = this.props;

        return (
            <tr className={gazetter.status}>
                <td>
                    <Autocomplete
                        menuStyle={styles.autocomplete.menuStyle}
                        wrapperStyle={styles.autocomplete.wrapperStyle}
                        getItemValue={(item) => item.fileName}
                        items={vocabularies}
                        renderItem={(item, isHighlighted) =>
                            <div style={{ height: '25px', cursor: 'pointer', background: isHighlighted ? 'lightgray' : 'white' }}>
                                {item.fileName}
                            </div>
                        }
                        shouldItemRender={(item, value) => {
                            return item.fileName.toLowerCase().indexOf(value.toLowerCase()) > -1;
                        }}
                        value={name}
                        onChange={(e) => {
                            this.changeRow([{field: 'name', value: e.target.value}]);
                        }}
                        onSelect={(name, item) => {
                            this.changeRow([{field: 'name', value: name}, {field: 'group', value: item.$target}]);
                        }}
                    />
                </td>
                <td className='group'>
                    <select type='text' onChange={(e) => {
                        this.changeRow([{field: 'group', value: e.target.value}]);
                    }} value={group}>
                        <option value='common'>common</option>
                        <option value='cargo'>cargo</option>
                        <option value='vessel'>vessel</option>
                    </select>
                </td>
                <td>
                    <input type='text' value={word} onChange={(e) => {
                        this.changeRow([{field: 'word', value: e.target.value}])
                    }}/>
                </td>
                <td className='features'>
                        {
                            gazetter.features
                                ?
                                JSON.stringify(gazetter.features, null, 2)
                                :
                                ''
                        }
                </td>

                <td className='management'>
                    <RaisedButton
                        labelStyle={styles.button.labelStyle}
                        style={styles.button.style}
                        buttonStyle={styles.button.buttonStyle}
                        label='DELETE'
                        onClick={() => { removeGazetter(gazetter) }}
                        secondary
                    />
                    {
                        gazetter.status && gazetter.status !== 'new'
                            ?
                            <RaisedButton
                                labelStyle={styles.button.labelStyle}
                                style={styles.button.style}
                                buttonStyle={styles.button.buttonStyle}
                                label='CLEAR'
                                onClick={() => { clearGazetter(gazetter) }}
                                primary
                            />
                            :
                            null
                    }
                </td>
            </tr>
        );
    }
}

export default GazetterItem;



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Gazetter/List/GazetterItem.jsx